import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAttention = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 11,
	viewBox: "0 0 12 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6 2.17636L10.1073 9.27273H1.89273L6 2.17636ZM6 0L0 10.3636H12L6 0Z",
			fill: "#4F4F4F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.54501 7.63623H5.4541V8.72714H6.54501V7.63623Z",
			fill: "#4F4F4F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.54501 4.36377H5.4541V7.09104H6.54501V4.36377Z",
			fill: "#4F4F4F"
		})
	]
});
export default SvgAttention;
